import authClient from '@/axiosClients/authClient'
import authLanguajeClient from '@/axiosClients/authLanguageClient'
import {errorHttpMessage} from '@/utils/errorDecodeUtil.js'
import authTenant from "@/axiosClients/authTenant";
import store from "@/store";
import {setAccessToken} from "@/modules/auth/store/mutations";

export const validateUser = async ({commit}, userLogin) => {
    try {
        const {data: result} = await authClient.post('/validate-username', {username: userLogin.username, email: userLogin.username})
        const {data, message, error, ask_business_name} = result.result

        return {message, error, ask_business_name}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const updatePermissionsUserSesion = ({commit}, permissions) => {
    commit('updatePermissionsUserSesion', permissions)
}

export const login = async ({commit}, userLogin) => {
    try {
        const deviceToken = localStorage.getItem('sherpa_device_token')
        const {data: result} = await authClient.post('/login', {
            username: userLogin.username,
            email: userLogin.username,
            password: userLogin.password,
            business: userLogin.business,
            is_need_business: userLogin.is_need_business,
            ...(deviceToken ? {device_token: deviceToken} : {}),
        })
        const {message, error, ask_business_name} = result.result

        if (!error) {
            const data = result.result.data

            // ── Detectar flujo 2FA ───────────────────────────────────────────
            if (data.status === 'pending_2fa') {
                commit('SET_TWO_FACTOR_PENDING', {
                    session_token: data.session_token,
                    channels:      data.channels,
                    user_name:     data.user_name,
                })
                return {message, error: false, ask_business_name, requires2FA: true, channels: data.channels, suggest_password_change: null}
            }
            // ────────────────────────────────────────────────────────────────

            const {accessToken, refreshToken, expiresIn, route_redirect, date, user, host, is_landlord: isLandlord, permissions} = data
            if (user && permissions) user.permissions = permissions
            commit('login', {user, accessToken, refreshToken, expiresIn, route_redirect, date, host, isLandlord})
        }

        return {message, error, ask_business_name, suggest_password_change: result.result.data?.suggest_password_change, requires2FA: false}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message:        error_http_message.message,
            data:           ex,
            error:          true,
            requires2FA:    false,
            lockout_type:   error_http_message.lockout_type   ?? null,
            lockout_minutes: error_http_message.lockout_minutes ?? null,
        }
    }
}

// ── Acciones 2FA ─────────────────────────────────────────────────────────────

export const send2FACode = async ({state}, channel) => {
    // `channel` puede ser el objeto completo { type, masked, method_id }
    // o solo el method_id (número). El backend requiere: session_token + method_id
    const methodId = (typeof channel === 'object') ? channel.method_id : channel
    await authClient.post('/two-factor/send', {
        session_token: state.twoFactorToken,
        method_id: methodId,
    })
}

export const verify2FACode = async ({state, commit}, {code, trustDevice, channel}) => {
    const {data: result} = await authClient.post('/two-factor/verify', {
        session_token: state.twoFactorToken,
        code,
        trust_device: trustDevice,
        channel: channel || undefined,
    })

    const payload = result.result.data

    if (trustDevice && payload.device_token) {
        localStorage.setItem('sherpa_device_token', payload.device_token)
    }

    // Limpiar estado 2FA
    commit('CLEAR_TWO_FACTOR')

    // Completar autenticación igual que el flujo normal
    const {accessToken, refreshToken, expiresIn, route_redirect, date, user, host, is_landlord: isLandlord, permissions} = payload
    if (user && permissions) user.permissions = permissions
    commit('login', {user, accessToken, refreshToken, expiresIn, route_redirect, date, host, isLandlord})

    return payload
}

// ─────────────────────────────────────────────────────────────────────────────


export const loginFromSSOResponse = async ({commit}, acessTokenResponse) => {
    try {

        commit('setTenantHost', acessTokenResponse.host)
        commit('setAccessToken', acessTokenResponse.accessToken)

        const {data: result} = await authTenant.post('/login-token', {})
        const {message, error, ask_business_name} = result.result

        if (!error) {
            const {accessToken, refreshToken, expiresIn, route_redirect, date, user, host, is_landlord: isLandlord, suggest_password_change, permissions} = result.result.data
            if (user && permissions) user.permissions = permissions
            commit('login', {user, accessToken, refreshToken, expiresIn, route_redirect, date, host, isLandlord})
        }

        return {message, error, ask_business_name, suggest_password_change: result.result.data?.suggest_password_change}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}


export const hasSSOConfigured = async ({commit}) => {
    try {

        const {data: result} = await authClient.post('/has-sso-configured', null, {
            baseURL: process.env.VUE_APP_AUTHENTICATION_URL,
        })
        const {message, error, data} = result.result

        return {message, error, data}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const verifyTokenStatuss = async ({commit}, token) => {
    try {
        //const { valid, response } = await authClient.post('/verify-token', {token})
        const {valid, response} = await new Promise(function (resolve, reject) {
            setTimeout(() => resolve({valid: true, response: 'token valido'}), 1000)
        })
        if (valid) {
            return valid
        }
    } catch (ex) {
        //console.log('Ha ocurrido un error al validar el token: ', ex)
    }
}

export const logout = async ({commit, getters}) => {
    try {
        // Limpiar estado 2FA antes de hacer logout
        commit('CLEAR_TWO_FACTOR')

        const token = getters.getToken
        const {data: result} = await authTenant.post('/logout', null, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        const {data, message, error} = result.result
        if (!error) {
            commit('logout')
        }
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const sendEmailRecoveryPassword = async ({commit}, user) => {
    try {
        commit('requestEmailRecoveryPassword', user.username)
        const {data: result} = await authClient.post('/recover-password', {username: user.username, business: user.business, is_need_business: user.is_need_business})
        const {message, error, type, data_identificator, password_reset_token, security_questions_available} = result.result
        return {message, error, type, data_identificator, password_reset_token, security_questions_available}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }

}

export const updatePasswordVerificationCode = async ({commit, getters}, payload) => {
    try {
        const data = {
            password_reset_token: getters.getPasswordResetToken,
            password: payload.password1.value,
            password_confirmation: payload.password2.value,
            code: payload.verificationCode.value
        }
        const {data: result} = await authClient.post('/reset-password', data)
        const {message, error} = result.result
        if (!error) {
            commit('requestEmailRecoveryPassword', null)
        }
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const updatePasswordWithoutVerificationCode = async ({commit, getters}, payload) => {

    try {
        const data = {
            password_reset_token: getters.getPasswordResetToken,
            password: payload.password1.value,
            password_confirmation: payload.password2.value,
        }
        const {data: result} = await authClient.post('/reset-password-without-code', data)
        const {message, error} = result.result

        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }

}

export const validateUserSecretQuestions = async ({commit, getters}, questions) => {

    try {

        const data = {
            password_reset_token: getters.getPasswordResetToken,
            questions: questions,
        }

        const {data: result} = await authClient.post('/validate-security-questions', data)
        const {message, error} = result.result

        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, error: true}
    }

}

export const refreshToken = async ({commit, getters}) => {

    try {

        const refreshToken = getters.getRefreshToken

        if (refreshToken != null) {
            const {data: result} = await authTenant.post('/refreshtoken', {refreshToken: refreshToken})
            const {data, message, error} = result.result

            if (!error) {
                const {token} = data
                commit('updateToken', {token})

                if (data?.user) {
                    const sessionUser = JSON.parse(sessionStorage.getItem('user') || '{}')
                    const refreshedUser = {
                        ...sessionUser,
                        ...data.user,
                        permissions: data.permissions ?? sessionUser.permissions,
                    }
                    commit('updateUser', refreshedUser)
                }
            }

            return {message, error}
        } else {
            return {message: "Refresh token doesnt exists", error: true}
        }

    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const clearAuthToken = async ({commit, getters}) => {

    try {

        commit('logout')

    } catch (ex) {
        return {message: "Cant remove sessionStorage", error: true}
    }
}

export const getQuestionsByUser = async ({commit, getters}, passwordResetToken) => {

    try {

        const {data: result} = await authClient.post('/get-security-questions', {password_reset_token: passwordResetToken})
        const {data, message, error} = result.result

        commit('setLang', data.lang)

        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}


export const getConfigurationsTenant = async ({commit, getters}) => {

    try {

        const {data: result} = await authLanguajeClient.get('/get-configurations-tenant')
        
        const {data, message, error} = result.result

        return {data, message, error}

    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const getConfigurationsTenantWithAuthTenant = async ({commit, getters}) => {

    try {

        const {data: result} = await authTenant.get('/get-configurations-tenant')
        
        const {data, message, error} = result.result

        return {data, message, error}

    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const validateInvitation = async ({commit}, token) => {
    try {
        const {data: result} = await authClient.post('/invitations/check-token', {token})
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const acceptInvitation = async ({commit}, payload) => {
    try {
        const {data: result} = await authClient.post('/invitations/accept', payload)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
    }
}
